import { useEffect } from 'react';

const SHORTCUT_KEY = 'k';

const isMacPlatform = () => /Mac/i.test(navigator.platform);

const useGlobalSearchShortcut = (onTrigger: () => void) => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handler = (event: KeyboardEvent) => {
      const cmdOrCtrl = isMacPlatform() ? event.metaKey : event.ctrlKey;

      if (cmdOrCtrl && event.key.toLowerCase() === SHORTCUT_KEY) {
        event.preventDefault();
        onTrigger();
      }
    };

    window.addEventListener('keydown', handler);

    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [onTrigger]);
};

export default useGlobalSearchShortcut;
